// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}


.button-container {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 40px auto 25px;
    flex-wrap: wrap;
}

.image-container img {
    height: 100vh;
    cursor: pointer;
}

/* Modal */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    z-index: 1000;
    cursor: pointer;
}

.modal-content img {
    max-width: 100%;
    max-height: 100%;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    cursor: pointer;
}

.modal-content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: black;
}

.bonus_1 {
    background: linear-gradient(to right, black 0%, black 40%, darkred 55%, red 70%, rgb(193, 36, 68) 100%);
    color: white;
}

.bonus_2 {
    background: linear-gradient(to right, black 0%, black 40%, darkgreen 55%, green 70%, lightgreen 100%);
    color: white;
}

.bonus_3 {
    background: linear-gradient(to right, black 0%, black 40%, navy 55%, royalblue 70%, skyblue 100%);
    color: white;
}

.img_full_e_bonus {
    width: 90vw;
    height: auto;
    display: block;
    margin: 0 auto;
    max-height: none !important;
}`, "",{"version":3,"sources":["webpack://./src/css/Bonus.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uGAAuG;IACvG,YAAY;AAChB;;AAEA;IACI,qGAAqG;IACrG,YAAY;AAChB;;AAEA;IACI,iGAAiG;IACjG,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,2BAA2B;AAC/B","sourcesContent":[".image-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin: 40px auto 25px;\n    flex-wrap: wrap;\n}\n\n.image-container img {\n    height: 100vh;\n    cursor: pointer;\n}\n\n/* Modal */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    z-index: 1000;\n    cursor: pointer;\n}\n\n.modal-content img {\n    max-width: 100%;\n    max-height: 100%;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    cursor: pointer;\n}\n\n.modal-content {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: black;\n}\n\n.bonus_1 {\n    background: linear-gradient(to right, black 0%, black 40%, darkred 55%, red 70%, rgb(193, 36, 68) 100%);\n    color: white;\n}\n\n.bonus_2 {\n    background: linear-gradient(to right, black 0%, black 40%, darkgreen 55%, green 70%, lightgreen 100%);\n    color: white;\n}\n\n.bonus_3 {\n    background: linear-gradient(to right, black 0%, black 40%, navy 55%, royalblue 70%, skyblue 100%);\n    color: white;\n}\n\n.img_full_e_bonus {\n    width: 90vw;\n    height: auto;\n    display: block;\n    margin: 0 auto;\n    max-height: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
